"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bs58PublicKey = exports.bs58Version = exports.bs58KeyType = exports.bs58NetType = exports.byteToKeyType = exports.byteToNetType = exports.bs58ToBin = exports.bs58CheckEncode = exports.deriveChecksumBits = exports.binaryToByte = exports.bytesToBinary = exports.lpad = exports.sha256 = exports.randomBytes = void 0;
/* eslint-disable no-bitwise */
const create_hash_1 = __importDefault(require("create-hash"));
const bs58_1 = __importDefault(require("bs58"));
const libsodium_wrappers_1 = __importDefault(require("libsodium-wrappers"));
const randomBytes = async (n) => {
    await libsodium_wrappers_1.default.ready;
    return Buffer.from(libsodium_wrappers_1.default.randombytes_buf(n));
};
exports.randomBytes = randomBytes;
const sha256 = (buffer) => create_hash_1.default('sha256').update(buffer).digest();
exports.sha256 = sha256;
const lpad = (str, padString, length) => {
    let strOut = str;
    while (strOut.length < length)
        strOut = padString + strOut;
    return strOut;
};
exports.lpad = lpad;
const bytesToBinary = (bytes) => bytes
    .map((x) => exports.lpad(x.toString(2), '0', 8))
    .join('');
exports.bytesToBinary = bytesToBinary;
const binaryToByte = (bin) => parseInt(bin, 2);
exports.binaryToByte = binaryToByte;
const deriveChecksumBits = (entropyBuffer) => {
    const ENT = entropyBuffer.length * 8;
    const CS = ENT / 32;
    const hash = exports.sha256(entropyBuffer).toString('hex');
    return exports.bytesToBinary([].slice.call(hash)).slice(0, CS);
};
exports.deriveChecksumBits = deriveChecksumBits;
const bs58CheckEncode = (version, binary) => {
    // VPayload = <<Version:8/unsigned-integer, Payload/binary>>,
    const vPayload = Buffer.concat([Buffer.from([version]), binary]);
    // <<Checksum:4/binary, _/binary>> = crypto:hash(sha256, crypto:hash(sha256, VPayload)),
    const checksum = exports.sha256(Buffer.from(exports.sha256(vPayload)));
    const checksumBytes = Buffer.alloc(4, checksum, 'hex');
    // Result = <<VPayload/binary, Checksum/binary>>,
    const result = Buffer.concat([vPayload, checksumBytes]);
    // base58:binary_to_base58(Result).
    return bs58_1.default.encode(result);
};
exports.bs58CheckEncode = bs58CheckEncode;
const bs58ToBin = (bs58Address) => {
    const bin = bs58_1.default.decode(bs58Address);
    const vPayload = bin.slice(0, -4);
    const payload = bin.slice(1, -4);
    const checksum = bin.slice(-4);
    const checksumVerify = exports.sha256(Buffer.from(exports.sha256(vPayload)));
    const checksumVerifyBytes = Buffer.alloc(4, checksumVerify, 'hex');
    if (!checksumVerifyBytes.equals(checksum)) {
        throw new Error('invalid checksum');
    }
    return payload;
};
exports.bs58ToBin = bs58ToBin;
const byteToNetType = (byte) => byte & 0xf0;
exports.byteToNetType = byteToNetType;
const byteToKeyType = (byte) => byte & 0x0f;
exports.byteToKeyType = byteToKeyType;
const bs58NetType = (bs58Address) => {
    const bin = exports.bs58ToBin(bs58Address);
    const byte = Buffer.from(bin).slice(0, 1)[0];
    return exports.byteToNetType(byte);
};
exports.bs58NetType = bs58NetType;
const bs58KeyType = (bs58Address) => {
    const bin = exports.bs58ToBin(bs58Address);
    const byte = Buffer.from(bin).slice(0, 1)[0];
    return exports.byteToKeyType(byte);
};
exports.bs58KeyType = bs58KeyType;
const bs58Version = (bs58Address) => {
    const bin = bs58_1.default.decode(bs58Address);
    const version = bin.slice(0, 1)[0];
    return version;
};
exports.bs58Version = bs58Version;
const bs58PublicKey = (bs58Address) => {
    const bin = exports.bs58ToBin(bs58Address);
    const publicKey = Buffer.from(bin).slice(1);
    return publicKey;
};
exports.bs58PublicKey = bs58PublicKey;
//# sourceMappingURL=utils.js.map